import { useEffect, useState } from "react";
import { IPanelTurnoEliminar } from "./PanelTurnoEliminar";
import { IResponseApiFluent, codigosRespuesta } from "../../../../../Interfaces/base/IResponse";
import { ITurnoEdit } from "../../../../../Interfaces/auxiliar/ITurno";
import { TurnoService } from "../../../../../services/auxiliar/turnoService";

export const UsePanelTurnoEliminar=(props:IPanelTurnoEliminar)=>{
    const [status, setStatus] = useState<codigosRespuesta>(0);
    const [mensaje, setMensaje] = useState<string>("");
     const [loading,setLoading]=useState<boolean>(false)
     const [contentShow, setcontentShow] = useState(true);
     const [loadprogress, setloadprogress] = useState(false);


     const initial:ITurnoEdit={
         nombre: "",
         codigo: "",
         horaInicio: "",
         horaFin: "",
         turnoId:""
     }
     const reset=()=>{
         setMensaje("")
         setRequest(initial)
         setStatus(0)
         props.onDismiss()
     }
     useEffect(()=>{
        if(props.item!=initial){
          setRequest({...request,nombre:props.item.nombre,turnoId:props.item.turnoId,
            codigo:props.item.codigo,horaFin:props.item.horaFin==null?"":props.item.horaFin.split(":").slice(0, 2).join(":"),
            horaInicio:props.item.horaInicio==null?"":props.item.horaInicio.split(":").slice(0, 2).join(":")})
          }
        },[props.item])
        const [request,setRequest]=useState<ITurnoEdit>(initial)
        const deleteTurno=()=>{
            setLoading(true)
            TurnoService.EliminarTurno(request.turnoId).then((res)=>{
                if(res.status==200){
                    setStatus(200)
                    setloadprogress(true);
                    setcontentShow(false);
                    setMensaje(res.data.mensaje);
                    setTimeout(()=>{
                      props.reload?.();
                      reset()
                  },3000)
                }else{
                    setStatus(500)
                }
                setLoading(false)
               
            }).catch((e)=>{
                if (
                    e.response?.data &&
                    'type' in e.response.data &&
                    'title' in e.response.data &&
                    'status' in e.response.data &&
                    'instance' in e.response.data &&
                    'errors' in e.response.data
                  ) {
                    const errorResponse = e.response.data as IResponseApiFluent;
                    const mensajeError = errorResponse.errors.join('\n');
                    setMensaje(mensajeError);
                  } else {
                    console.log('Error detallado:', e);
                    setMensaje("Error Inesperado");
                  }
                  setStatus(500);
                  setLoading(false);
            })
        }


        return {contentShow,loadprogress, request,setRequest,deleteTurno,loading,reset,mensaje,status}
}